import { buildTextdomain } from 'react-gettext';
import Localization from '@dealersites/core/translations/Localization';

const i18n = (global.i18n = global.i18n || {});
const DS_OEM_TEXT_DOMAIN = 'dealersite-oem';

const translations = {
  en: buildTextdomain(require('./en.json')),
  fr: buildTextdomain(require('./fr.json')),
};

const oemLocalization = new Localization(translations, DS_OEM_TEXT_DOMAIN);
i18n.oem = oemLocalization;

export { oemLocalization, translations, DS_OEM_TEXT_DOMAIN };
